import { onAjaxContentLoaded } from '../js/generic/evented'
import { GetAttr } from './utils/getAttr'

const instance = '[data-js-right-sidebar]'

export default class RightSidebarModel {
  els = {
    openBtn: '[data-js-right-sidebar-open-trigger]',
    closeBtn: '[data-js-right-sidebar-close-btn]',
    overlay: "[data-js-right-sidebar-overlay]"
  }

  states = {
    sidebar: {
      isActive: false
    },
    overlay: {
      isActive: "is-active"
    }
  }

  stateClasses = {
    sidebar: {
      isActive: "is-active"
    },
    overlay: {
      isActive: "is-active"
    }
  }

  constructor () {
    this.instance = document.querySelector(instance)
    this.openTriggers = document.querySelectorAll(this.els.openBtn)
    this.closeBtns = document.querySelectorAll(this.els.closeBtn)
    this.overlay = document.querySelector(this.els.overlay)
    this.boundToggleState = this.toggleState.bind(this);
    this.bindEvents()
  }

  toggleState() {
    this.states.sidebar.isActive = !this.states.sidebar.isActive
    this.states.overlay.isActive = !this.states.overlay.isActive
    this.toggleClasses()
  }

  toggleClasses() {
    this.instance.classList.toggle(this.stateClasses.sidebar.isActive)
    this.overlay.classList.toggle(this.stateClasses.overlay.isActive)
  }

  handleClickOverlay(e) {
    if (this.states.sidebar.isActive) {
      this.toggleState()
    }
  }
  handleKeyDown(e) {
    if (e.key === 'Escape' && this.states.sidebar.isActive) {
      this.toggleState()
    }
  }
  bindEvents () {
    this.overlay?.addEventListener("click", (e) => {
      this.handleClickOverlay(e)
    })
    document.addEventListener('keydown', (e) => this.handleKeyDown(e))
    document.addEventListener("click", (e) => {
      if (event.target.hasAttribute(GetAttr(this.els.openBtn)) || event.target.hasAttribute(GetAttr(this.els.closeBtn))) {
        this.toggleState()
      }
    }, true)


  }
}
